// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"533":"4d31a616","693":"37d21a29"}[chunkId] + ".chunk.css";
};